import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import heroImg from '../assets/011v2.jpg';

const LANG_MAP = { de: 'de', en: 'en', es: 'es', fr: 'fr', zh: 'zh', ko: 'ko', th: 'th', ja: 'ja' };

export const SEOHead = ({ pageTitleOverride, descriptionOverride }) => {
  const { t, i18n } = useTranslation();
  const lang = LANG_MAP[i18n.language] || 'en';

  const title = pageTitleOverride || t('seo.title');
  const description = descriptionOverride || t('seo.description');
  const ogTitle = t('seo.og_title');
  const ogDesc = t('seo.og_description');
  const canonicalBase = 'https://legend-spa.me';
  const ogImage = 'https://customer-assets.emergentagent.com/job_f0c2f209-4d99-481d-9ef1-4ea8761a84c1/artifacts/g8xsg0wt_011v2.jpg';

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Legend Spa Hotel GmbH" />
      <meta name="keywords" content="Legend Spa Hotel, Longevity, Wellness, Isla Margarita, Venezuela, Biohacking, Stem Cell Therapy, Caribbean Luxury, Cell Regeneration, Cryo" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDesc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Legend Spa Hotel" />
      <meta property="og:locale" content={
        lang === 'de' ? 'de_DE' : lang === 'es' ? 'es_ES' : lang === 'fr' ? 'fr_FR' :
        lang === 'zh' ? 'zh_CN' : lang === 'ko' ? 'ko_KR' : lang === 'th' ? 'th_TH' :
        lang === 'ja' ? 'ja_JP' : 'en_US'
      } />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDesc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Theme */}
      <meta name="theme-color" content="#05080F" />
      <meta name="msapplication-TileColor" content="#D4AF37" />

      {/* Canonical */}
      <link rel="canonical" href={canonicalBase} />

      {/* Alternate hreflang */}
      <link rel="alternate" hrefLang="en" href={canonicalBase} />
      <link rel="alternate" hrefLang="de" href={canonicalBase} />
      <link rel="alternate" hrefLang="es" href={canonicalBase} />
      <link rel="alternate" hrefLang="fr" href={canonicalBase} />
      <link rel="alternate" hrefLang="zh" href={canonicalBase} />
      <link rel="alternate" hrefLang="ko" href={canonicalBase} />
      <link rel="alternate" hrefLang="th" href={canonicalBase} />
      <link rel="alternate" hrefLang="ja" href={canonicalBase} />
      <link rel="alternate" hrefLang="x-default" href={canonicalBase} />
    </Helmet>
  );
};
